import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBreadcrumbs,{staticClass:"breadcrumbs-container",attrs:{"items":_setup.indexedBreadcrumbs},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c(VBreadcrumbsItem,{class:[
        'breadcrumb',
        item.breadcrumbIndex === (_setup.indexedBreadcrumbs && _setup.indexedBreadcrumbs.length - 1) &&
          'breadcrumb--last',
      ],attrs:{"data-testid":item.breadcrumbIndex},on:{"click":function($event){return _setup.onBreadcrumbClick(item.breadcrumbIndex, item.onClick)}}},[_vm._v(" "+_vm._s(item.title)+" ")])]}},{key:"divider",fn:function(){return [_c(VIcon,[_vm._v(" "+_vm._s(_vm.dividerIcon ? _vm.dividerIcon : "$icon_arrow_right")+" ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }